import { useContext } from 'react';
import SeoPageContext from 'components/SeoPage/SeoPageContext';

const useSeoPage = () => useContext(SeoPageContext);

export default useSeoPage;
